@if (shellLoadFailure$ | async; as shellLoadFailure) {
    @if (!shouldSuppressShellLoadFailure()) {
        <div class="shell-state shell-state--terminal" data-testid="shell-load-failure">
            <div class="logo-container">
                <img alt="Markedspartner Logo"
                     src="/assets/images/logos/shine.svg"/>
            </div>
            <div class="shell-state__panel">
                <p class="shell-state__eyebrow">Access interrupted</p>
                <h1>{{ shellLoadFailureContent[shellLoadFailure].title }}</h1>
                <p>{{ shellLoadFailureContent[shellLoadFailure].message }}</p>
                <div class="shell-state__actions">
                    <button type="button" (click)="retryShellLoadFailure(shellLoadFailure)">
                        {{ shellLoadFailureContent[shellLoadFailure].actionLabel }}
                    </button>
                </div>
            </div>
        </div>
    }
} @else if (loadingOverlay$ | async; as loadingOverlay) {
    <div class="loading-container" aria-live="polite" aria-busy="true" role="status">
        <div class="loading-shell">
            <div class="logo-container">
                <img alt="Markedspartner Logo"
                     src="/assets/images/logos/shine.svg"/>
            </div>
            <div class="loading-animation">
                <div class="loading-text">
                    <p>{{ loadingOverlay.message }}</p>
                </div>
                <div class="loading-bar">
                    <div class="shine-effect"></div>
                </div>
            </div>
        </div>
    </div>
}

<router-outlet></router-outlet>
